import { InputAdornment, MenuItem, TextField } from "@mui/material";
import { ChangeEvent, FunctionComponent } from "react";

import { useTranslation } from "react-i18next";

import { Role } from "@/enum";

import { SvgIcon } from "@/components/Icon/SvgIcon";

import Mail from "@assets/icons/mail.svg?react";

import { UserRole } from "../../UserRoles/schema/roles";
import { EMAIL_REGEX } from "../../Course/components/AddTeamModal";

interface InviteUserItemProps {
	email: string;
	role: string;
	roles: UserRole[];
	onEmailChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	onRoleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const InviteUserItem: FunctionComponent<InviteUserItemProps> = ({
	email,
	role,
	roles,
	onEmailChange,
	onRoleChange,
}) => {
	const { t } = useTranslation();
	const isValidEmail = email?.length ? email?.match(EMAIL_REGEX) : true;

	return (
		<div className="flex flex-row w-full gap-2 relative">
			<TextField
				InputProps={{
					startAdornment: (
						<InputAdornment
							position="start"
							sx={{
								"&:not(.MuiInputAdornment-hiddenLabel)": {
									marginTop: "0px !important",
								},
							}}
						>
							<div className="mr-2 flex items-center">
								<SvgIcon className="w-[20px] h-[20px] text-gray-500" svgIcon={Mail} />
							</div>{" "}
						</InputAdornment>
					),
				}}
				className="w-full"
				error={!isValidEmail}
				inputProps={{
					style: {
						display: "flex",
						alignItems: "center",
						padding: "10px 0px",
					},
				}}
				placeholder="you@example.com"
				sx={{
					"& .MuiInputBase-root": {
						marginBottom: "16px !important",
					},
				}}
				value={email}
				onChange={onEmailChange}
			/>
			<TextField
				select
				SelectProps={{
					MenuProps: {
						PaperProps: {
							sx: {
								"& .MuiMenuItem-root": {
									display: "flex",
									alignItems: "center",
								},
							},
						},
					},
				}}
				className="w-[160px] h-[44px]"
				inputProps={{
					style: {
						display: "flex",
						alignItems: "center",
					},
				}}
				sx={{
					"& .MuiSelect-select": {
						alignSelf: "flex-end",
					},
					"& .MuiInputBase-root": {
						marginBottom: "0px",
					},
				}}
				value={role ?? Role.USER}
				onChange={onRoleChange}
			>
				{roles.map((role) => (
					<MenuItem key={role.id} value={role.name}>
						{role.name}
					</MenuItem>
				))}
			</TextField>
			{!isValidEmail && (
				<p className="absolute -bottom-1 text-[12px] text-danger">{t("courses.invalid-email")}</p>
			)}
		</div>
	);
};
